await import('/var/www/lmewms-app-ui/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/var/www/lmewms-app-ui/src/.umi/umi.ts');
export default 1;